import React from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import AtlasV2TotalTrafficDonutChart from 'src/components/AtlasV2Components/AtlasV2TrafficPageComponents/AtlasV2TotalTraffic/AtlasV2TotalTrafficDonutChart';
import { useAtlasV2MetricByWeekId } from 'src/serverProxy/useAtlasV2MetricByWeekId';
import AtlasV2ComparableSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2ComparableSplineChart';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';

/**
 * Shows donut chart and bar charts for the top section of Total Traffic
 */
export const AtlasV2TrafficTopSection = () => {
  const { primaryTotal: totalClicks, isLoading: totalLoading } = useAtlasV2MetricByWeekId({
    indexName: 'traffic',
    fieldName: 'totalClicks'
  });
  const { primaryTotal: organicClicks, isLoading: organicLoading } = useAtlasV2MetricByWeekId({
    indexName: 'traffic',
    fieldName: 'organicClicks'
  });
  const { primaryTotal: paidTraffic, isLoading: paidLoading } = useAtlasV2MetricByWeekId({
    indexName: 'traffic',
    fieldName: 'adClicks'
  });
  const { primaryTotal: otherTraffic, isLoading: otherLoading } = useAtlasV2MetricByWeekId({
    indexName: 'traffic',
    fieldName: 'otherClicks'
  });
  const { primaryTotal: dspClicks, isLoading: dspLoading } = useAtlasV2MetricByWeekId({
    indexName: 'traffic',
    fieldName: 'otherAdClicks'
  });

  const loading = organicLoading || paidLoading || otherLoading || dspLoading || totalLoading;

  return (
    <Grid2 display="grid" gridTemplateColumns="308px 655px" justifyContent="space-between" alignItems="center">
      <AtlasV2TotalTrafficDonutChart
        loading={loading}
        dspClicks={dspClicks}
        organicClicks={organicClicks}
        otherTraffic={otherTraffic}
        paidTraffic={paidTraffic}
        totalClicks={totalClicks}
      />
      <Flex>
        <AtlasV2ComparableSplineChart
          indexName="traffic"
          fieldName="totalClicks"
          showTitleSummary={false}
          splineChartLoadingProps={{
            width: 664
          }}
          chartOptionsOverride={{
            chart: {
              height: 280,
              width: 664
            }
          }}
        />
      </Flex>
    </Grid2>
  );
};
